angular.module('qkr').directive('formViewConditionalTooltip', ($compile, $timeout) => ({
        restrict: 'A',
        terminal: true,
        priority: 0,
        link(scope, element, attrs) {
            $timeout(() => {
                element.text(attrs.conditionalTooltipText);

                if (element[0].scrollHeight > element[0].clientHeight) {
                    element.attr('uib-tooltip', attrs.conditionalTooltipText);
                    element.attr('tooltip-placement', attrs.conditionalTooltipPlacement);
                    element.attr('tooltip-class', attrs.conditionalTooltipClass);

                    element.removeAttr('form-view-conditional-tooltip');
                    element.removeAttr('conditional-tooltip-text');
                    element.removeAttr('conditional-tooltip-placement');
                    element.removeAttr('conditional-tooltip-class');

                    $compile(element)(scope);
                }
            });
        }
    }));



// WEBPACK FOOTER //
// ./src/directives/formViewConditionalTooltip.js